import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";

const AuthCallback = () => {
  const { handleRedirectCallback } = useAuth0();
  const history = useHistory();

  useEffect(() => {
    const processLogin = async () => {
      try {
        await handleRedirectCallback();
        const redirectPath = localStorage.getItem("auth_redirect_path") || "/";
        localStorage.removeItem("auth_redirect_path");
        history.replace(redirectPath);
      } catch (error) {
        console.error("❌ Error processing login:", error);
      }
    };

    processLogin();
  }, [handleRedirectCallback, history]);

  return <h2>Redirecting...</h2>;
};

export default AuthCallback;


